import { ReactComponent as MassageSvg } from '../assets/svgs-orig/001-body-massage.svg';
import { ReactComponent as BeautySvg } from '../assets/svgs-orig/005-makeover.svg';
import { ReactComponent as FitnessSvg } from '../assets/svgs-orig/008-fitness.svg';
import { ReactComponent as NutritionSvg } from '../assets/svgs-orig/013-health.svg';
import { ReactComponent as TutoringSvg } from '../assets/svgs-orig/tutor.svg';
import { ReactComponent as KidsSvg } from '../assets/svgs-orig/playtime.svg';
import { ReactComponent as WealthSvg } from '../assets/svgs-orig/wealth.svg';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import BrushIcon from '@mui/icons-material/Brush';
import CakeIcon from '@mui/icons-material/Cake';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import CodeIcon from '@mui/icons-material/Code';
import CoffeeIcon from '@mui/icons-material/Coffee';
import ComputerIcon from '@mui/icons-material/Computer';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import DiamondIcon from '@mui/icons-material/Diamond';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import ElderlyIcon from '@mui/icons-material/Elderly';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import EmojiNatureIcon from '@mui/icons-material/EmojiNature';
import FaceIcon from '@mui/icons-material/Face';
import Face2Icon from '@mui/icons-material/Face2';
import Face3Icon from '@mui/icons-material/Face3';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import GroupsIcon from '@mui/icons-material/Groups';
import HandymanIcon from '@mui/icons-material/Handyman';
import HealingIcon from '@mui/icons-material/Healing';
import HikingIcon from '@mui/icons-material/Hiking';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import LanguageIcon from '@mui/icons-material/Language';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import PaletteIcon from '@mui/icons-material/Palette';
import PersonIcon from '@mui/icons-material/Person';
import PetsIcon from '@mui/icons-material/Pets';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import PianoIcon from '@mui/icons-material/Piano';
import PoolIcon from '@mui/icons-material/Pool';
import PsychologyIcon from '@mui/icons-material/Psychology';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import SavingsIcon from '@mui/icons-material/Savings';
import SchoolIcon from '@mui/icons-material/School';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import SpaIcon from '@mui/icons-material/Spa';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';
import SportsMartialArtsIcon from '@mui/icons-material/SportsMartialArts';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import StarIcon from '@mui/icons-material/Star';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import WbSunnyIcon from '@mui/icons-material/WbSunny';
import YardIcon from '@mui/icons-material/Yard';

export const MUI_CATEGORY_ICONS = {
  AccessibilityNew: AccessibilityNewIcon,
  AcUnit: AcUnitIcon,
  AccountBalance: AccountBalanceIcon,
  AutoStories: AutoStoriesIcon,
  Brush: BrushIcon,
  Cake: CakeIcon,
  Checkroom: CheckroomIcon,
  ChildCare: ChildCareIcon,
  ChildFriendly: ChildFriendlyIcon,
  CleaningServices: CleaningServicesIcon,
  Code: CodeIcon,
  Coffee: CoffeeIcon,
  Computer: ComputerIcon,
  ContentCut: ContentCutIcon,
  Diamond: DiamondIcon,
  DirectionsBike: DirectionsBikeIcon,
  DirectionsRun: DirectionsRunIcon,
  Elderly: ElderlyIcon,
  EmojiEvents: EmojiEventsIcon,
  EmojiNature: EmojiNatureIcon,
  Face: FaceIcon,
  Face2: Face2Icon,
  Face3: Face3Icon,
  Favorite: FavoriteIcon,
  FitnessCenter: FitnessCenterIcon,
  Groups: GroupsIcon,
  Handyman: HandymanIcon,
  Healing: HealingIcon,
  Hiking: HikingIcon,
  HomeRepairService: HomeRepairServiceIcon,
  Language: LanguageIcon,
  LocalDining: LocalDiningIcon,
  LocalFlorist: LocalFloristIcon,
  LocalHospital: LocalHospitalIcon,
  MedicalServices: MedicalServicesIcon,
  MenuBook: MenuBookIcon,
  MonitorHeart: MonitorHeartIcon,
  MusicNote: MusicNoteIcon,
  Palette: PaletteIcon,
  Person: PersonIcon,
  Pets: PetsIcon,
  PhotoCamera: PhotoCameraIcon,
  Piano: PianoIcon,
  Pool: PoolIcon,
  Psychology: PsychologyIcon,
  Restaurant: RestaurantIcon,
  Savings: SavingsIcon,
  School: SchoolIcon,
  SelfImprovement: SelfImprovementIcon,
  ShoppingBag: ShoppingBagIcon,
  Spa: SpaIcon,
  SportsBasketball: SportsBasketballIcon,
  SportsGymnastics: SportsGymnasticsIcon,
  SportsMartialArts: SportsMartialArtsIcon,
  SportsSoccer: SportsSoccerIcon,
  SportsTennis: SportsTennisIcon,
  Star: StarIcon,
  Vaccines: VaccinesIcon,
  VolunteerActivism: VolunteerActivismIcon,
  WbSunny: WbSunnyIcon,
  Yard: YardIcon,
};

export const LEGACY_CATEGORY_ICONS = {
  massage: MassageSvg,
  beauty: BeautySvg,
  fitness: FitnessSvg,
  nutrition: NutritionSvg,
  tutoring: TutoringSvg,
  wealth: WealthSvg,
  kids: KidsSvg,
};

export const DEFAULT_CATEGORY_CONFIGS = [
  { key: 'Massage', displayName: 'Massage', icon: 'massage', order: 1 },
  { key: 'Beauty', displayName: 'Beauty', icon: 'beauty', order: 2 },
  { key: 'Fitness', displayName: 'Fitness', icon: 'fitness', order: 3 },
  { key: 'Nutrition', displayName: 'Nutrition', icon: 'nutrition', order: 4 },
  { key: 'Tutoring', displayName: 'Tutoring', icon: 'tutoring', order: 5 },
  { key: 'Wealth', displayName: 'Wealth', icon: 'wealth', order: 6 },
  { key: 'Kids', displayName: 'Children', icon: 'kids', order: 7 },
];

export const DEFAULT_CATEGORY_ICON_BY_KEY = DEFAULT_CATEGORY_CONFIGS.reduce((m, c) => { m[c.key.toLowerCase()] = c.icon; return m; }, {});
